import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/groups/{slug}/students` is a redirect, not a screen.
 *
 * Legacy's `WBS_Group_Extension::load_default_subnav_screen` (`:329-335`) 302s
 * the bare tab slug to the FIRST registered subnav whenever no action variable
 * follows it, and All Students is first on all four Students-tab extensions.
 * Without this the route renders the tab bar over an empty outlet.
 *
 * `beforeLoad`, not a component effect — the answer needs no payload, so
 * bouncing before the subtree mounts avoids a frame of empty tab body. Same
 * shape as `$groupName.students.quiz-submissions.index.tsx:22`.
 *
 * Only the BARE slug. Legacy's `templateNotFound()` (`:341-346`) also redirects
 * any unrecognised slug under `/students/`, and that is deliberately not built:
 * a catch-all splat is a second routing mechanism for a URL nobody navigates to
 * (W3.9 N9).
 */
export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/students/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/groups/$groupName/students/all-students/',
      params: { groupName: params.groupName },
      replace: true,
    });
  },
});
